import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Grommet } from "grommet";
import { createBrowserHistory } from "history";
import React, { lazy, Suspense, useEffect, useReducer } from "react";
import { CookiesProvider } from "react-cookie";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import "./App.scss";
import LoadingPage from "./components/LoadingPage";
import ProtectedRoute from "./components/ProtectedRoute";
import CourtRoot from "./containers/CourtRoot";
import Forbidden from "./containers/Forbidden";
import Login from "./containers/Login";
import {
  determineIsTd,
  determineIsMegaOp,
  getPermissionCode,
} from "./utils/pagePermission";
import theme from "./utils/theme";

import "./utils/i18n";
import auth from "./utils/auth";

export const AuthContext = React.createContext();

const history = createBrowserHistory();

history.listen((_) => {
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
});

const initState = {
  userId: null,
  permissions: [],
  // permissionGroup: null,
  routePermissionId: null,
  userGroupId: null,
  isTd: false,
  isMegaOp: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      localStorage.setItem("userId", action.payload.id);
      localStorage.setItem("username", action.payload.username);
      localStorage.setItem("operatorId", action.payload.operatorId);
      localStorage.setItem("userGroupId", action.payload.userGroupId);
      localStorage.setItem("permissions", action.payload.permissionPage);
      localStorage.setItem("pwExpiry", action.payload.pwExpiry);
      if (action.payload.routePermissionId) {
        localStorage.setItem(
          "routePermissionId",
          action.payload.routePermissionId
        );
      }
      if (action.payload.isTd) {
        localStorage.setItem("isTd", action.payload.isTd);
      }
      if (action.payload.isMegaOp) {
        localStorage.setItem("isMegaOp", action.payload.isMegaOp);
      }
      localStorage.setItem("version", "1.0");
      return {
        ...state,
        userId: action.payload.id,
        operatorId: action.payload.operatorId,
        permissions: action.payload.permissionPage,
        routePermissionId: action.payload.routePermissionId,
        pwExpiry: action.payload.pwExpiry,
      };
    case "LOGOUT":
      localStorage.removeItem("userId");
      localStorage.removeItem("operatorId");
      localStorage.removeItem("permissions");
      localStorage.removeItem("isTd");
      localStorage.removeItem("isMegaOp");
      localStorage.removeItem("routePermissionId");
      localStorage.removeItem("pwExpiry");
      return {
        ...state,
        userId: null,
        operatorId: null,
        permissions: [],
        isTd: false,
        isMegaOp: false,
        routePermissionId: null,
        pwExpiry: null,
      };
    default:
      return state;
  }
};

function App() {
  const [state, dispatch] = useReducer(reducer, initState);

  useEffect(() => {
    auth.setDispatch(dispatch);

    // if (!localStorage.getItem("version")) {
    //   dispatch({ type: "LOGOUT" });
    // }
  }, []);

  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      <Grommet theme={theme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <CookiesProvider>
            <Router history={history}>
              <Suspense fallback={<LoadingPage />}>
                <Switch>
                  {/* <Route path="/" exact component={Root} />
              <Route path="/add" exact component={Root} /> */}
                  {/* <Route
                    path="/"
                    exact
                    render={(props) => <Redirect to="/login" />}
                  /> */}
                  <Route path="/login" exact component={Login} />
                  <Route path="/forbidden" exact component={Forbidden} />
                  <ProtectedRoute
                    pagePermission={getPermissionCode("court-root")}
                    path="/"
                    component={CourtRoot}
                  />
                  {/* <ProtectedRoute path="/:userId/:courtId" component={CourtRoot} /> */}
                  {/* <Route path="/:courtId" component={CourtRoot} /> */}
                </Switch>
              </Suspense>
            </Router>
          </CookiesProvider>
        </MuiPickersUtilsProvider>
      </Grommet>
    </AuthContext.Provider>
  );
}

export default App;
